module.exports = __webpack_public_path__ + "static/media/delete-icon.d3f4b98f.svg";